/**
 * @fileoverview Tag CVA variants.
 *
 * Split out of `tag.tsx` (react-refresh/only-export-components).
 */

import { cva } from "class-variance-authority";

export const tagVariants = cva(
  "inline-flex items-center rounded-lg border bg-muted/30 font-medium text-foreground transition-colors",
  {
    variants: {
      size: {
        sm: "gap-1 px-1.5 py-0 text-[10px]",
        md: "gap-1.5 px-2.5 py-0.5 text-xs",
        lg: "gap-2 px-3 py-1 text-sm",
      },
    },
    defaultVariants: {
      size: "md",
    },
  },
);
